export interface ICostCenterFormValues {
    number?: number;
    description: string;
}

export const defaultCostCenterFormValues: ICostCenterFormValues = {
    description: '',
};
